import { makeApiCall } from '../utils/apiConfig';

/**
 * Public vendor sign-up API. No auth header: the rep filling in the form does
 * not have a Motzu account yet, which is the whole point of the flow.
 */

export type BrandMatchOutcome = 'unclaimed' | 'claimed' | 'new' | 'inactive';

export interface BrandMatchResult {
  outcome: BrandMatchOutcome;
  brandName: string;
  brandId: string | null;
}

export interface RepInvitePreview {
  valid: boolean;
  brandId?: string;
  brandName?: string;
  /** Masked address, e.g. j***@brand.com. */
  emailHint?: string;
}

export type ProofKind = 'domain' | 'letter' | 'dns';

export const vendorSignupApi = {
  matchBrand: async (name: string): Promise<BrandMatchResult> => {
    const response = await makeApiCall(`/public/vendor-signup/brand-match?name=${encodeURIComponent(name)}`);
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(payload.error?.message || payload.message || `HTTP ${response.status}`);
    }
    return payload.data as BrandMatchResult;
  },
  /** What an emailed brand rep invitation is for; `valid: false` for every dead link alike. */
  previewRepInvite: async (token: string): Promise<RepInvitePreview> => {
    const response = await makeApiCall(`/public/vendor-signup/rep-invite?token=${encodeURIComponent(token)}`);
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) return { valid: false };
    return (payload.data as RepInvitePreview) || { valid: false };
  },
};
